import { render, staticRenderFns } from "./ElementStudioSaveNewDialog.vue?vue&type=template&id=af2362fa&"
import script from "./ElementStudioSaveNewDialog.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioSaveNewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports